import { CodeleapQueryClient, ReactQuery } from '@codeleap/query'
import { useEffect } from '@codeleap/hooks'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { persistQueryClient } from '@tanstack/react-query-persist-client'

const reactQueryClient = new ReactQuery.QueryClient({
  // defaultOptions: {
  //   queries: {
  //     staleTime: 0,
  //     gcTime: 0,
  //   },
  // },
})

const queryClient = new CodeleapQueryClient(reactQueryClient)

function usePersistQueryClient() {
  useEffect(() => {
    const persister = createSyncStoragePersister({
      storage: window.localStorage,
    })

    persistQueryClient({
      queryClient: reactQueryClient,
      persister,
      dehydrateOptions: {
        shouldDehydrateQuery: (query) => {
          // Don't persist queries with gcTime: 0
          return query.gcTime !== 0
        },
      },
    })
  }, [queryClient])
}

export { queryClient, usePersistQueryClient }
